import React from 'react'
import PropTypes from 'prop-types'

export default class Progress extends React.PureComponent {
  static get propTypes () {
    return {
      step: PropTypes.number,
      total: PropTypes.number
    }
  }

  static get defaultProps () {
    return {
      step: 0,
      total: 0
    }
  }

  render () {
    if ((this.props.step <= 0)) {
      return
    }

    return (
      <div className='step-index'>Step {this.props.step}/{this.props.total}</div>
    )
  }
}
